// extracted by mini-css-extract-plugin
export default {"content":"HRtM3fUh_U"};